module.exports = __webpack_public_path__ + "ae.no1.574ed531.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ae.no1.jpg
// module id = 39jp
// module chunks = 0